import axios from 'axios';
import React, { useEffect, useState, useContext } from "react";
import Particles from "react-particles-js";
import Layout from "../components/Layout";
import Socialicons from "../components/Socialicons";
import Service from "../components/Service";
import AppContext from '../components/AppContext';

function Home({lightMode}){
  const [information, setInformation] = useState("");
  const [services, setServices] = useState([]);
  const appContextRoot = useContext(AppContext);
  const isSlovakLang = appContextRoot.appContext.displaySlovak;
  const paramConfig = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        value: "#ffffff"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: "top",
        out_mode: "out"
      }
    }
  };

  const paramConfigLight = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        value: "#000000"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: "top",
        out_mode: "out"
      }
    }
  };
  useEffect(() =>{
    axios.get(isSlovakLang ? '/api/information?lang=sk' : '/api/information')
    .then( response => {
      setInformation(response.data);
    });
    axios.get(isSlovakLang ? '/api/services?lang=sk' : '/api/services').then((response) => {
      setServices(response.data);
    });
  }, [isSlovakLang])
  return (
    <Layout>
      <div className="mi-home-area mi-padding-section mi-padding-bottom">
        <Particles className="mi-home-particle" params={lightMode? paramConfigLight : paramConfig} />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12">
              <div className="mi-home-content">
                <h1>
                  {information._welcome} <span className="color-theme">{information.name}</span>
                </h1>
                <p>{information.aboutContent}</p>
                <Socialicons bordered />
              </div>
            </div>
          </div>  
          {/* <Sectiontitle title="Services" /> */}
          <div className="mi-service-wrapper">
            <div className="row mt-30-reverse">
              {services.map((service) => (
                <div
                  className="col-lg-4 col-md-6 col-12 mt-30"
                  key={service.title}
                >
                  <Service content={service} />
                </div>
              ))}
            </div>
          </div>        
        </div>
      </div>
    </Layout>
  );
}

export default Home;
